import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'
import { MuiTextFieldFormik } from '@sales-center/components'

type Props = {
  id: number
}

export function ActivityStatusSelect(props: Props) {
  return (
    <Field
      component={MuiTextFieldFormik}
      disabled={false}
      fullWidth
      label="Status"
      margin="normal"
      name="status"
      required={false}
      select
      size="small"
      data-test-id={`activity-status-select-${props.id}`}
    >
      <MenuItem value="Todo">To Do</MenuItem>
      <MenuItem value="InProgress">In Progress</MenuItem>
      <MenuItem value="Deferred">Deferred</MenuItem>
      <MenuItem value="Complete">Complete</MenuItem>
    </Field>
  )
}
